import { stringifySave } from '../../../helpers/JsonHelpers';
// ToDo: maybe implement later
var BroadcastChannelPolyfill = /** @class */ (function () {
    function BroadcastChannelPolyfill(name) {
        this.name = name;
    }
    BroadcastChannelPolyfill.prototype.postMessage = function (data) {
        window.localStorage.setItem(this.name, stringifySave(data));
    };
    BroadcastChannelPolyfill.prototype.addEventListener = function (_event, eventHandler) {
        window.addEventListener('storage', function (storageEvent) {
            console.log('storageEvent', storageEvent);
            eventHandler({ data: 'ds' });
        });
    };
    return BroadcastChannelPolyfill;
}());
export default BroadcastChannelPolyfill;
//# sourceMappingURL=BroadcastChannelPolyfill.js.map